import React from 'react'

export default function PaymentSkelton() {
  return (
    <div className="fixed w-full h-full inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-sm rounded-lg shadow-lg p-6 animate-pulse">

        {/* Title Skeleton */}
        <div className="h-5 bg-gray-300 rounded w-3/4 mb-2"></div>

        {/* Subtitle Skeleton */}
        <div className="h-4 bg-gray-300 rounded w-2/3 mb-4"></div>

        <div className="space-y-4">

          {/* Card Number Field Skeleton */}
          <div>
            <div className="h-4 bg-gray-300 rounded w-1/3 mb-2"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
          </div>

          {/* Expiry and CVC Fields Skeleton */}
          <div className="flex space-x-4">
            <div className="flex-1">
              <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
              <div className="h-10 bg-gray-200 rounded w-full"></div>
            </div>
            <div className="flex-1">
              <div className="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
              <div className="h-10 bg-gray-200 rounded w-full"></div>
            </div>
          </div>

          {/* Country Select Skeleton */}
          <div>
            <div className="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
            <div className="h-10 bg-gray-200 rounded w-full"></div>
          </div>

          {/* Terms Text Skeleton */}
          <div className="space-y-1">
            <div className="h-3 bg-gray-200 rounded w-full"></div>
            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
          </div>

          {/* Button Skeleton */}
          <div className="h-10 bg-gray-300 rounded w-full mt-4"></div>
        </div>
      </div>
    </div>
  )
}
